import StoreContext from './storeContext'

export default StoreContext